// frontend/src/App.js

import React from 'react';
import Dashboard from './pages/Dashboard';

function App() {
    return (
        <div className="App">
            <Dashboard />
        </div>
    );
}

export default App;